import { action, computed, observable } from 'mobx';
import Alert from 'react-s-alert';
import { AppManager, Variables } from 'core/index';
import { Input } from 'core/mutation';
// import { routerStore } from 'core/routing';

// import { ProjectContextModel, ProjectContextApp } from 'apps/context/app';
// import { FileApp } from 'apps/file/app';

import { OrderModel, OrderApp } from 'apps/order/app';
import {
  OrderQuery,
  IntermediatorOrderQuery,
  UpdateOrderStatusMutation,
} from 'apps/order/gql';
import { ensureIsGraphqlId } from 'utils/dgraphId';
import { clientStore } from 'apps/client/app';

export default class OrderAppManager extends AppManager {
  static registryName = 'OrderAppManager';
  fileId = null;
  spaceId = null;
  orderId = null;
  @observable order = null;
  @observable shareFileId = null;

  constructor(parent, { file = null, signedInProfile = null, orderId = null }) {
    super(parent);
    this.fileId = file?.id;
    this.spaceId = signedInProfile?.inSpace.id;
    this.orderId = ensureIsGraphqlId(orderId, 'Order');
    this.AppRef('order', OrderApp);

    this.variables = new Variables({
      id: () => this.orderId,
    });
    this.variables.onChange(['id'], this.LoadOrderQuery);
  }

  @computed get loading() {
    return !this.order;
  }

  @action LoadOrderQuery = () => {
    const isIntermediator = clientStore.hasRole('INTERMEDIATOR');
    const Query = isIntermediator ? IntermediatorOrderQuery : OrderQuery;
    const q = new Query(this, {
      queryKey: 'order',
      // onSysErr: this.onOrderQueryError,
    });
    q.process(
      order => (order ? OrderModel.Load(order) : null),
      this.UpdateOrder,
    );
    q.query();
  };

  @action UpdateOrder = order => {
    if (!order) return;
    this.order = order;
  };

  @action UpdateOrderStatus = newStatus => {
    const updateInput = new Input({
      input: {
        id: this.orderId,
        status: newStatus,
      },
    });

    const onUpdateOrderStateError = () => {
      Alert.error('Sorry, there was an error changing the Order Status.');
    };

    const updateRequestForQuoteStateMutation = new UpdateOrderStatusMutation(
      updateInput,
      null,
      {},
      true,
    );
    updateRequestForQuoteStateMutation.setCallbacks({
      onSysErr: onUpdateOrderStateError,
      onUserErr: onUpdateOrderStateError,
      // onSuccess:() => { },
    });
    updateRequestForQuoteStateMutation.mutate();
  };
}
